import type { FC } from "react";

interface NoDataDisplayProps {
  message: string;
  altText?: string;
}

const NoDataDisplay: FC<NoDataDisplayProps> = ({
  message,
  altText = "Not Found",
}) => (
  <div className="no-data-display">
    <img src="/Icons/no-data.gif" alt={altText} className="no-data-image" />
    <p className="no-data-message">{message}</p>
  </div>
);

export default NoDataDisplay;
